<p-skeleton *ngIf="!thumbnail" height="100px" width="167.39px"></p-skeleton>
<img *ngIf="thumbnail" [alt]=" alt ?? file.name" [src]="thumbnail" decoding="async" height="100">
